import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import FormControl from '@mui/material/FormControl';
import DownloadIcon from '@mui/icons-material/Download';
import CircularProgress from '@mui/material/CircularProgress';

import {
    Box,
    Grid,
    Typography,
    Tooltip,
    IconButton,
    Chip,
    InputBase,
    Divider,
    Snackbar,
    Alert,
    Modal,
    Card,
    CardContent,
    Stack,
    Avatar,
    TextField,
    FormHelperText,
    Button,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';

import MenuItem from '@mui/material/MenuItem';

import Skeleton from '@mui/material/Skeleton';

import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import VisibilityIcon from '@mui/icons-material/Visibility';

import BusinessIcon from '@mui/icons-material/Business';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import TimelineIcon from '@mui/icons-material/Timeline';
import CloseIcon from '@mui/icons-material/Close';
import CallIcon from '@mui/icons-material/Call';
import ForumIcon from '@mui/icons-material/Forum';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        xs: '95%',
        md: 900
    },
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 3,
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const AgreementsComp = (props) => {
    const [openDetailsModal, setOpenDetailsModal] = React.useState(false);
    const [selectedAgreement, setSelectedAgreement] = React.useState({});

    const FormatDateTime = (date) => {

        if (!date) return 'N/A';

        let formatDate =
            new Date(
                new Date(date).getTime()
                - (new Date(date).getTimezoneOffset() * 60000)
            )
                .toISOString()
                .substr(0, 19)
                .replace('T', ' ');

        return formatDate;
    };

    const formatDuration = (seconds) => {

        if (!seconds) return 'Not Available';

        const mins = Math.floor(seconds / 60);

        const secs = seconds % 60;

        return `${mins}m ${secs}s`;

    };

    const ViewAgreementDetails = (item) => {
        setSelectedAgreement(item);
        setOpenDetailsModal(true);
    };

    return (
        <Box>

            {/* TOP BAR */}
            <Box>

                <Grid container spacing={2}>

                    <Grid item xs={12} md={4} mt={2}>

                        <Paper
                            component="form"
                            sx={{
                                p: '2px 4px',
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%'
                            }}
                        >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search By Partner Name..."
                                value={props.mystate.agreementSearchObj?.txtAgreementSearchName || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtAgreementSearchName')
                                }
                            />

                            <IconButton sx={{ p: '10px' }}>
                                <SearchIcon
                                    onClick={() =>
                                        props.SearchAgreementList('direct', '')
                                    }
                                />
                            </IconButton>

                            <Divider
                                sx={{ height: 28, m: 0.5 }}
                                orientation="vertical"
                            />

                            <IconButton sx={{ p: '10px' }}>
                                <CachedIcon
                                    onClick={() =>
                                        props.SearchAgreementList('reload', '')
                                    }
                                />
                            </IconButton>

                        </Paper>

                    </Grid>

                    <Grid item xs={12} md={8} mt={2} textAlign={'right'}>

                        <Tooltip arrow title="Add New Agreement">

                            <IconButton
                                onClick={() =>
                                    props.NavigateTo('agreement/new')
                                }
                                className='grey-theme-btn'
                            >
                                <AddIcon />
                            </IconButton>

                        </Tooltip>

                        {/* <Tooltip arrow title="Filter">

                            <IconButton
                                onClick={() => props.ToggleFilter()}
                                className='grey-theme-btn'
                            >
                                <FilterListIcon />
                            </IconButton>

                        </Tooltip> */}

                    </Grid>

                </Grid>

            </Box>

            {/* TABLE */}
            <Box mt={3}>

                {
                    props.mystate.getAgreementList === false ?

                        window.innerWidth > 567 ?

                            <Paper
                                sx={{
                                    width: '100%',
                                    overflow: 'hidden'
                                }}
                            >

                                <TableContainer
                                    sx={{
                                        maxHeight: 'calc(100vh - 250px)'
                                    }}
                                >

                                    <Table stickyHeader>

                                        <TableHead>

                                            <TableRow>

                                                {/* SR NO */}
                                                <TableCell className='table-head-cell'>
                                                    Sr No
                                                </TableCell>


                                                {/* ADDED BY */}
                                                <TableCell className='table-head-cell'>
                                                    Added By
                                                </TableCell>


                                                {/* COMPANY */}
                                                <TableCell className='table-head-cell'>
                                                    Company Name
                                                </TableCell>


                                                {/* REFERRAL PARTNER */}
                                                <TableCell className='table-head-cell'>
                                                    Referral Partner
                                                </TableCell>


                                                {/* DATE */}
                                                <TableCell className='table-head-cell'>
                                                    Agreement Date & Month
                                                </TableCell>


                                                {/* FEE */}
                                                <TableCell className='table-head-cell'>
                                                    Agreement Fee
                                                </TableCell>


                                                {/* ACTION */}
                                                <TableCell className='table-head-cell'>
                                                    Action
                                                </TableCell>

                                            </TableRow>

                                        </TableHead>


                                        <TableBody>

                                            {
                                                props.mystate.agreementList?.length > 0 ?

                                                    props.mystate.agreementList.map((item, i) => (

                                                        <TableRow
                                                            hover
                                                            key={item._id}
                                                        >

                                                            {/* =========================
                                                    SR NO
                                                ========================= */}

                                                            <TableCell>

                                                                {
                                                                    (
                                                                        (
                                                                            props.mystate.setNo - 1
                                                                        ) *
                                                                        props.mystate.perSet
                                                                    ) + i + 1
                                                                }

                                                            </TableCell>


                                                            {/* =========================
                                                    ADDED BY
                                                ========================= */}

                                                            <TableCell>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.added_by ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>

                                                            </TableCell>


                                                            {/* =========================
                                                    COMPANY NAME
                                                    NAME + CONTACT + EMAIL
                                                ========================= */}

                                                            <TableCell>

                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.company_name ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {
                                                                        item.company_representative_name ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{
                                                                        lineBreak: 'anywhere'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.company_representative_email ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>

                                                            </TableCell>


                                                            {/* =========================
                                                    REFERRAL PARTNER
                                                    COMPANY + CONTACT + EMAIL
                                                ========================= */}

                                                            <TableCell>

                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.referral_partner_company_name ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {
                                                                        item.referral_partner_representative_name ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{
                                                                        lineBreak: 'anywhere'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.referral_partner_representative_email ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>

                                                            </TableCell>


                                                            {/* =========================
                                                    AGREEMENT DATE & MONTH
                                                ========================= */}

                                                            <TableCell>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {
                                                                        item.agreement_date ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                >
                                                                    {
                                                                        item.agreement_month ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>

                                                            </TableCell>


                                                            {/* =========================
                                                    AGREEMENT FEE
                                                ========================= */}

                                                            <TableCell>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    ₹ {
                                                                        item.referral_fee ||
                                                                        '0'
                                                                    }
                                                                </Typography>

                                                            </TableCell>


                                                            {/* =========================
                                                    ACTION
                                                ========================= */}

                                                            <TableCell>

                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        gap: 1
                                                                    }}
                                                                >

                                                                    {/* VIEW */}



                                                                    <Tooltip
                                                                        arrow
                                                                        title="Download Agreement PDF"
                                                                    >
                                                                        <IconButton
                                                                            size="small"
                                                                            disabled={props.mystate.downloadingAgreementId === item._id}
                                                                            onClick={() => props.DownloadAgreementPdf(item)}
                                                                        >
                                                                            {props.mystate.downloadingAgreementId === item._id ? (
                                                                                <CircularProgress size={20} />
                                                                            ) : (
                                                                                <DownloadIcon sx={{ color: '#0284c7' }} />
                                                                            )}
                                                                        </IconButton>
                                                                    </Tooltip>




                                                                    {/* EDIT */}

                                                                    <Tooltip
                                                                        arrow
                                                                        title="Edit Agreement"
                                                                    >

                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                props.NavigateTo(
                                                                                    'agreement/' +
                                                                                    item._id
                                                                                )
                                                                            }
                                                                        >

                                                                            <EditIcon
                                                                                className="grey-theme-btn"
                                                                            />

                                                                        </IconButton>

                                                                    </Tooltip>

                                                                </Box>

                                                            </TableCell>

                                                        </TableRow>

                                                    ))

                                                    :

                                                    <TableRow>

                                                        <TableCell
                                                            colSpan={7}
                                                            align="center"
                                                        >

                                                            <Typography py={3}>
                                                                No Agreements Found
                                                            </Typography>

                                                        </TableCell>

                                                    </TableRow>
                                            }

                                        </TableBody>

                                    </Table>

                                </TableContainer>

                            </Paper>


                            :

                            /* =========================================================
                               MOBILE VIEW
                            ========================================================= */

                            <Box>

                                {
                                    props.mystate.agreementList?.length > 0 ?

                                        props.mystate.agreementList.map((item, i) => (

                                            <Card
                                                key={item._id}
                                                sx={{
                                                    mb: 2,
                                                    borderRadius: 4,
                                                    boxShadow:
                                                        '0 4px 20px rgba(0,0,0,0.08)',
                                                    overflow: 'hidden'
                                                }}
                                            >

                                                <CardContent>

                                                    {/* =========================
                                            HEADER
                                        ========================= */}

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            mb: 2
                                                        }}
                                                    >

                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 2,
                                                                flex: 1
                                                            }}
                                                        >

                                                            {/* COMPANY AVATAR */}

                                                            <Avatar
                                                                sx={{
                                                                    width: 55,
                                                                    height: 55,
                                                                    bgcolor: '#042740',
                                                                    fontWeight: 700,
                                                                    fontSize: 18
                                                                }}
                                                            >
                                                                {
                                                                    item.company_name
                                                                        ? item.company_name
                                                                            .split(' ')
                                                                            .map(
                                                                                name =>
                                                                                    name[0]
                                                                            )
                                                                            .slice(0, 2)
                                                                            .join('')
                                                                            .toUpperCase()
                                                                        : 'NA'
                                                                }
                                                            </Avatar>


                                                            {/* COMPANY DETAILS */}

                                                            <Box sx={{ flex: 1 }}>

                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.company_name ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                >
                                                                    {
                                                                        item.company_representative_name ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>


                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{
                                                                        display: 'block',
                                                                        wordBreak:
                                                                            'break-word'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.company_representative_email ||
                                                                        'N/A'
                                                                    }
                                                                </Typography>

                                                            </Box>

                                                        </Box>

                                                    </Box>


                                                    {/* =========================
                                            AGREEMENT DETAILS
                                        ========================= */}

                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        sx={{
                                                            mb: 2,
                                                            p: 2,
                                                            backgroundColor: '#f8fafc',
                                                            borderRadius: 2
                                                        }}
                                                    >

                                                        {/* ADDED BY */}

                                                        <Grid item xs={6}>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                            >
                                                                Added By
                                                            </Typography>

                                                            <Typography
                                                                variant="body2"
                                                                fontWeight={600}
                                                            >
                                                                {
                                                                    item.added_by ||
                                                                    'N/A'
                                                                }
                                                            </Typography>

                                                        </Grid>


                                                        {/* REFERRAL PARTNER */}

                                                        <Grid item xs={6}>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                            >
                                                                Referral Partner
                                                            </Typography>

                                                            <Typography
                                                                variant="body2"
                                                                fontWeight={600}
                                                            >
                                                                {
                                                                    item.referral_partner_company_name ||
                                                                    'N/A'
                                                                }
                                                            </Typography>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                    display: 'block',
                                                                    wordBreak:
                                                                        'break-word'
                                                                }}
                                                            >
                                                                {
                                                                    item.referral_partner_representative_name ||
                                                                    'N/A'
                                                                }
                                                            </Typography>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                    display: 'block',
                                                                    wordBreak:
                                                                        'break-word'
                                                                }}
                                                            >
                                                                {
                                                                    item.referral_partner_representative_email ||
                                                                    'N/A'
                                                                }
                                                            </Typography>

                                                        </Grid>


                                                        {/* AGREEMENT DATE */}

                                                        <Grid item xs={6}>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                            >
                                                                Agreement Date
                                                            </Typography>

                                                            <Typography
                                                                variant="body2"
                                                                fontWeight={600}
                                                            >
                                                                {
                                                                    item.agreement_date ||
                                                                    'N/A'
                                                                }
                                                            </Typography>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                            >
                                                                {
                                                                    item.agreement_month ||
                                                                    'N/A'
                                                                }
                                                            </Typography>

                                                        </Grid>


                                                        {/* AGREEMENT FEE */}

                                                        <Grid item xs={6}>

                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                            >
                                                                Agreement Fee
                                                            </Typography>

                                                            <Typography
                                                                variant="body2"
                                                                fontWeight={700}
                                                            >
                                                                ₹ {
                                                                    item.referral_fee ||
                                                                    '0'
                                                                }
                                                            </Typography>

                                                        </Grid>

                                                    </Grid>


                                                    {/* =========================
                                            ACTION BUTTONS
                                        ========================= */}

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                            gap: 5,
                                                            alignItems: 'center',
                                                            pt: 1.5,
                                                            borderTop:
                                                                '1px solid #e5e7eb'
                                                        }}
                                                    >

                                                        {/* VIEW */}

                                                        <Tooltip title="View Details">

                                                            <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                    ViewAgreementDetails(
                                                                        item
                                                                    )
                                                                }
                                                            >

                                                                <VisibilityIcon
                                                                    sx={{
                                                                        color: '#0284c7'
                                                                    }}
                                                                />

                                                            </IconButton>

                                                        </Tooltip>


                                                        {/* EDIT */}

                                                        <Tooltip title="Edit Agreement">

                                                            <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                    props.NavigateTo(
                                                                        'agreement/' +
                                                                        item._id
                                                                    )
                                                                }
                                                            >

                                                                <EditIcon
                                                                    sx={{
                                                                        color: '#64748b'
                                                                    }}
                                                                />

                                                            </IconButton>

                                                        </Tooltip>

                                                    </Box>

                                                </CardContent>

                                            </Card>

                                        ))

                                        :

                                        <Typography
                                            align="center"
                                            py={3}
                                        >
                                            No Agreements Found
                                        </Typography>
                                }

                            </Box>


                        :

                        /* =========================================================
                           LOADING
                        ========================================================= */

                        <Box>

                            <Skeleton height={75} />

                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                height={250}
                            />

                            <Skeleton height={75} />

                        </Box>
                }


                {/* =========================================================
        PAGINATION
    ========================================================= */}

                {
                    props.mystate.agreementList?.length > 0 ?

                        <TablePagination
                            rowsPerPageOptions={[10, 50, 100]}
                            component="div"
                            count={props.mystate.totalRecords}
                            rowsPerPage={props.mystate.perSet}
                            page={props.mystate.setNo - 1}
                            onPageChange={(e) =>
                                props.HandleChangePage(
                                    e,
                                    props.mystate.setNo - 1
                                )
                            }
                            onRowsPerPageChange={(e) =>
                                props.HandleChangeRowsPerPage(e)
                            }
                        />

                        :

                        null
                }

            </Box>
            {/* DETAILS MODAL */}
            <Modal
                open={openDetailsModal}
                onClose={() => setOpenDetailsModal(false)}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '95%', md: '90%' },
                        maxWidth: 1300,
                        maxHeight: '92vh',
                        overflowY: 'auto',
                        bgcolor: '#f4f7fb',
                        borderRadius: 4,
                        p: 3,
                        boxShadow: 24
                    }}
                >

                    {/* HEADER */}
                    <Box
                        sx={{
                            background:
                                'linear-gradient(135deg,#042740 0%,#0b4d78 100%)',
                            borderRadius: 3,
                            p: 3,
                            color: '#fff',
                            mb: 3
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <Typography variant="h4" fontWeight={700}>
                                    {selectedAgreement.agreement_name}
                                </Typography>

                                <Typography variant="body1">
                                    {selectedAgreement.contact_number}
                                </Typography>

                                <Typography variant="body2">
                                    {selectedAgreement.email}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Box textAlign="right">
                                    <Chip
                                        label={
                                            selectedAgreement.application_status || 'N/A'
                                        }
                                        sx={{
                                            bgcolor: '#16a34a',
                                            color: '#fff',
                                            fontWeight: 600
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* BASIC DETAILS */}
                    <Card sx={{ mb: 3 }}>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight={600}
                                color="#042740"
                                mb={3}
                            >
                                Basic Details
                            </Typography>

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        First Name
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.first_name}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Last Name
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.last_name}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        DOB
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.date_of_birth}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Age
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.age}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Qualification
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.qualification}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Institute Name
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.agreement_referred_by || 'N/A'}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Marital Status
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.marital_status}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Kids Count
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.kids_count}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>

                    {/* CONTACT DETAILS */}
                    <Card sx={{ mb: 3 }}>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight={600}
                                color="#042740"
                                mb={3}
                            >
                                Contact Details
                            </Typography>

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption">
                                        Contact Number
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.contact_number}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption">
                                        WhatsApp Number
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.whatsapp_number}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption">
                                        Guardian Number
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.guardian_number}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="caption">
                                        Current Address
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.current_address}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="caption">
                                        Permanent Address
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.permanent_address}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>

                    {/* GERMAN DETAILS */}
                    <Card sx={{ mb: 3 }}>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight={600}
                                color="#042740"
                                mb={3}
                            >
                                German Learning Details
                            </Typography>

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption">
                                        Started Learning German
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.started_learning_german}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption">
                                        German Level
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.german_level}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption">
                                        Total Experience
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.total_experience}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>

                    {/* EMPLOYMENT */}
                    <Card sx={{ mb: 3 }}>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight={600}
                                color="#042740"
                                mb={3}
                            >
                                Employment Details
                            </Typography>

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Employer Name
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.employer_name}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Employer Type
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.employer_type}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Job Location
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.job_location}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption">
                                        Salary Offered
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        {selectedAgreement.salary_offered}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>


                    {/* DOCUMENTS */}
                    <Card>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight={600}
                                color="#042740"
                                mb={3}
                            >
                                Documents Available
                            </Typography>

                            <Grid container spacing={2}>

                                {[
                                    ['Birth Certificate', selectedAgreement.birth_certificate],
                                    ['10th Marksheet', selectedAgreement.tenth_marksheet],
                                    ['12th Marksheet', selectedAgreement.twelfth_marksheet],
                                    ['Nursing Certificate', selectedAgreement.nursing_certificate],
                                    ['Transcript', selectedAgreement.transcript_of_records],
                                    ['Passport', selectedAgreement.passport],
                                    ['German Resume', selectedAgreement.german_resume],
                                    ['Marriage Certificate', selectedAgreement.marriage_certificate],
                                    ['Good Standing', selectedAgreement.good_standing_certificate],
                                    ['PCC', selectedAgreement.police_clearance_certificate],
                                    ['Vaccination', selectedAgreement.vaccination],
                                    ['B1 Certificate', selectedAgreement.b1_german_certificate],
                                    ['B2 Certificate', selectedAgreement.b2_german_certificate],
                                    ['Experience Letter', selectedAgreement.experience_letter]
                                ].map(([label, value]) => (
                                    <Grid item xs={12} md={3} key={label}>
                                        <Chip
                                            label={label}
                                            color={
                                                value === true ||
                                                    value === 'true'
                                                    ? 'success'
                                                    : 'default'
                                            }
                                            variant={
                                                value === true ||
                                                    value === 'true'
                                                    ? 'filled'
                                                    : 'outlined'
                                            }
                                        />
                                    </Grid>
                                ))}

                            </Grid>

                        </CardContent>
                    </Card>

                </Box>
            </Modal>

            <Modal
                open={props.mystate.openInteractionBox}
                // onClose={() => props.ToggleInteractionBox()}
                onClose={(event, reason) => {
                    // ❌ Prevent close when clicking backdrop
                    if (reason === "backdropClick") return;
                    props.ToggleInteractionBox()
                }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-Interaction"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Interaction
                    </Typography>
                    <Box mt={1}>
                        <FormControl fullWidth>
                            <TextField
                                select
                                value={props.interactionData.ddlLeadStatus || ''}
                                label="Select Status*"
                                error={props.interactionData.ddlLeadStatusErr == undefined || props.interactionData.ddlLeadStatusErr == '' ? false : true}
                                onChange={(e) => props.HandleInputs(e, 'ddlLeadStatus')}
                            >

                                <MenuItem key={''} value={'RNR'}>{'RNR'}</MenuItem>
                                <MenuItem key={''} value={'Call Back'}>{'Call Back'}</MenuItem>
                                <MenuItem key={''} value={'Active'}>{'Active'}</MenuItem>
                                <MenuItem key={''} value={'Onboarding'}>{'Onboarding'}</MenuItem>
                                <MenuItem key={''} value={'Inactive'}>{'Inactive'}</MenuItem>

                            </TextField>
                            <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadStatusErr}</FormHelperText>
                        </FormControl>
                    </Box>
                    {
                        props.interactionData.ddlLeadStatus === 'Call Back' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtCallBackDateTime')} label="CallBack DateTime*" value={dayjs(props.interactionData.txtCallBackDateTime != undefined ? props.interactionData.txtCallBackDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtCallBackDateTimeErr == undefined || props.interactionData.txtCallBackDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtCallBackDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }
                    {
                        props.interactionData.ddlLeadStatus === 'Onboarding' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtOnboardingDateTime')} label="Onboarding DateTime*" value={dayjs(props.interactionData.txtOnboardingDateTime != undefined ? props.interactionData.txtOnboardingDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtOnboardingDateTimeErr == undefined || props.interactionData.txtOnboardingDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtOnboardingDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlLeadStatus === 'Dead' ?
                            <Box mt={1}>
                                <TextField multiline rows={2} className="text-input" id="txtDeadReason" name='txtDeadReason' error={props.interactionData.txtDeadReasonErr == undefined || props.interactionData.txtDeadReasonErr == '' ? false : true} helperText={props.interactionData.txtDeadReasonErr} onChange={(e) => props.HandleInputs(e, 'txtDeadReason')} value={props.interactionData.txtDeadReason || ''} label="Dead Reason" variant="outlined" />
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtDeadReasonErr}</FormHelperText>
                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlLeadStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadDepartment || ''}
                                        label="Select Department*"
                                        error={props.interactionData.ddlLeadDepartmentErr == undefined || props.interactionData.ddlLeadDepartmentErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadDepartment')}
                                    >
                                        <MenuItem value={'Sales TL'}>{'Sales TL'}</MenuItem>
                                        <MenuItem value={'Sales'}>{'Sales'}</MenuItem>
                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadDepartmentErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }
                    {
                        props.interactionData.ddlLeadStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadOwner || ''}
                                        label="Select Owner*"
                                        error={props.interactionData.ddlLeadOwnerErr == undefined || props.interactionData.ddlLeadOwnerErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadOwner')}
                                    >
                                        {
                                            props.mystate.userListData.map((item, i) =>
                                                item.user_profile_name === props.interactionData.ddlLeadDepartment ?
                                                    <MenuItem key={i} value={item.user_name}>{item.user_name}</MenuItem>
                                                    :
                                                    null
                                            )
                                        }


                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadOwnerErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }



                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtInteractionDesc" name='txtInteractionDesc' error={props.interactionData.txtInteractionDescErr == undefined || props.interactionData.txtInteractionDescErr == '' ? false : true} helperText={props.interactionData.txtInteractionDescErr} onChange={(e) => props.HandleInputs(e, 'txtInteractionDesc')} value={props.interactionData.txtInteractionDesc || ''} label="Enter Description" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddNewInteraction()}>Add Interaction</Button>
                            </Grid>

                        </Grid>
                    </Box>

                </Box>
            </Modal>

            {/* ALERT */}
            <Snackbar
                open={props.mystate.showAlert}
                autoHideDuration={1000}
                onClose={() =>
                    props.HandleCloseAlertMsg(
                        props.mystate.alertType
                    )
                }
            >

                <Alert
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.mystate.alertMsg}
                </Alert>

            </Snackbar>

            <Dialog
                open={props.timelinePopup}
                onClose={() => props.CloseTimeLine()}
                fullWidth
                maxWidth='md'
            >

                <DialogTitle>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >

                        <Typography
                            variant='h6'
                            fontWeight={600}
                        >
                            Institute Timeline
                        </Typography>

                        <IconButton
                            onClick={() => props.CloseTimeLine()}
                        >
                            <CloseIcon />
                        </IconButton>

                    </Box>

                </DialogTitle>

                <DialogContent dividers>

                    <Timeline position='right'>

                        {props.timelineData && props.timelineData.map((item, index) => (

                            <TimelineItem key={index}>

                                <TimelineSeparator>

                                    <TimelineDot
                                        color={
                                            item.timeline_type === 'call'
                                                ? 'success'
                                                : 'primary'
                                        }
                                    >

                                        {
                                            item.timeline_type === 'call'
                                                ? <CallIcon fontSize='small' />
                                                : <ForumIcon fontSize='small' />
                                        }

                                    </TimelineDot>

                                    {
                                        index !== props.timelineData.length - 1 &&
                                        <TimelineConnector />
                                    }

                                </TimelineSeparator>

                                <TimelineContent>

                                    <Box
                                        sx={{
                                            p: 2,
                                            border: '1px solid #e5e7eb',
                                            borderRadius: 2,
                                            mb: 2,
                                            background: '#fff'
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 1,
                                                flexWrap: 'wrap'
                                            }}
                                        >

                                            <Chip
                                                size='small'
                                                label={
                                                    item.timeline_type === 'call'
                                                        ? 'Call'
                                                        : 'Interaction'
                                                }
                                                color={
                                                    item.timeline_type === 'call'
                                                        ? 'success'
                                                        : 'primary'
                                                }
                                            />

                                            <Typography
                                                variant='caption'
                                                color='text.secondary'
                                            >
                                                {item.added_on}
                                            </Typography>

                                        </Box>

                                        {
                                            item.timeline_type === 'interaction' && (

                                                <>

                                                    <Typography
                                                        variant='body2'
                                                        fontWeight={600}
                                                        gutterBottom
                                                    >
                                                        Status :
                                                        {' '}
                                                        {item.interaction_status}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                    >
                                                        {item.description}
                                                    </Typography>

                                                </>

                                            )
                                        }

                                        {
                                            item.timeline_type === 'call' && (

                                                <>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        Call Status :
                                                        {' '}
                                                        <b>
                                                            {item.call_status}
                                                        </b>
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        From :
                                                        {' '}
                                                        {item.call_from_number}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        To :
                                                        {' '}
                                                        {item.call_to_number}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        Duration :
                                                        {' '}
                                                        <b>
                                                            {formatDuration(item.duration)}
                                                        </b>
                                                    </Typography>

                                                    {
                                                        item.recording_url && (

                                                            <Box sx={{ mt: 2 }}>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ mb: 1 }}
                                                                >
                                                                    <b>Recording</b>
                                                                </Typography>

                                                                <audio
                                                                    controls
                                                                    preload="none"
                                                                    style={{
                                                                        width: '100%'
                                                                    }}
                                                                >
                                                                    <source src={item.recording_url} />
                                                                </audio>
                                                            </Box>

                                                        )
                                                    }

                                                    <Typography
                                                        variant='body2'
                                                    >
                                                        By :
                                                        {' '}
                                                        {item.call_by}
                                                    </Typography>

                                                </>

                                            )
                                        }

                                    </Box>

                                </TimelineContent>

                            </TimelineItem>

                        ))}

                    </Timeline>

                </DialogContent>

            </Dialog>

        </Box>
    );
};